(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
class VideoCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.vc-track');
    this.cards = container.querySelectorAll('.video-card');
    this.prevBtn = container.querySelector('.vc-prev');
    this.nextBtn = container.querySelector('.vc-next');
    this.dots = container.querySelectorAll('.vc-dot');
    
    this.isHovering = false;
    this.currentPlayingCard = null;
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.globalMuted = true;

    this.init();
  }

  init() {
    this.cards.forEach(card => {
      const video = card.querySelector('video');
      const volumeBtn = card.querySelector('.vc-volume-toggle');

      card.addEventListener('mouseenter', () => {
        if (this.isDown) return;
        this.isHovering = true;
        this.playCard(card);
      });
      
      card.addEventListener('mouseleave', () => {
        this.isHovering = false;
      });

      card.addEventListener('click', (e) => {
        if (e.target.closest('.vc-volume-toggle')) return; 
        if(!this.isDown) this.playCard(card);
      });

      if (volumeBtn && video) {
        volumeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleMute(card);
        });
      }
    });

    // Observer for video playing
    this.observer = new IntersectionObserver((entries) => {
      if (this.isHovering || this.isDown) return;
      const visibleEntries = entries.filter(entry => entry.isIntersecting);
      if (visibleEntries.length > 0) {
        this.findAndPlayCenter(visibleEntries);
      }
    }, { root: this.track, threshold: 0.6 });

    this.cards.forEach(card => this.observer.observe(card));

    // Scroll listener for Mobile Dots
    this.track.addEventListener('scroll', () => this.handleScrollProgress());

    if (this.prevBtn && this.nextBtn) {
      this.prevBtn.addEventListener('click', () => this.scroll(-1));
      this.nextBtn.addEventListener('click', () => this.scroll(1));
    }

    this.track.addEventListener('mousedown', (e) => this.startDrag(e));
    this.track.addEventListener('mouseleave', () => this.stopDrag());
    this.track.addEventListener('mouseup', () => this.stopDrag());
    this.track.addEventListener('mousemove', (e) => this.drag(e));
    
    setTimeout(() => this.triggerScrollEvent(), 500);
  }

  handleScrollProgress() {
    if (this.dots.length === 0) return;

    const trackWidth = this.track.scrollWidth - this.track.clientWidth;
    const progress = this.track.scrollLeft / trackWidth;
    const activeIndex = Math.round(progress * (this.dots.length - 1));

    this.dots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }

  toggleMute(card) {
    const video = card.querySelector('video');
    if (!video) return;

    this.globalMuted = !video.muted;
    
    this.cards.forEach(c => {
      const v = c.querySelector('video');
      const b = c.querySelector('.vc-volume-toggle');
      if (v) {
        v.muted = this.globalMuted;
        if (this.globalMuted) b?.classList.remove('is-unmuted');
        else b?.classList.add('is-unmuted');
      }
    });
  }

  playCard(cardToPlay) {
    if (this.currentPlayingCard === cardToPlay && !cardToPlay.querySelector('video').paused) return;

    this.cards.forEach(card => {
      const vid = card.querySelector('video');
      if (vid && card !== cardToPlay) {
        vid.pause();
        vid.currentTime = 0;
        card.classList.remove('video-playing');
      }
    });

    const video = cardToPlay.querySelector('video');
    const volumeBtn = cardToPlay.querySelector('.vc-volume-toggle');
    
    if (video) {
      video.muted = this.globalMuted;
      if (!this.globalMuted) volumeBtn?.classList.add('is-unmuted');
      
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          cardToPlay.classList.add('video-playing');
          this.currentPlayingCard = cardToPlay;
        }).catch(err => console.log('Autoplay prevented'));
      }
    }
  }

  findAndPlayCenter(visibleEntries) {
    let closestEntry = null;
    let minDistance = Infinity;
    const trackCenter = this.track.getBoundingClientRect().width / 2;

    visibleEntries.forEach(entry => {
      const rect = entry.target.getBoundingClientRect();
      const trackRect = this.track.getBoundingClientRect();
      const relativeCardCenter = (rect.left - trackRect.left) + (rect.width / 2);
      const distance = Math.abs(relativeCardCenter - trackCenter);

      if (distance < minDistance) {
        minDistance = distance;
        closestEntry = entry;
      }
    });

    if (closestEntry) {
      this.playCard(closestEntry.target);
    }
  }

  scroll(direction) {
    const cardWidth = this.cards[0].offsetWidth;
    const style = window.getComputedStyle(this.track);
    const gap = parseFloat(style.gap || 16);
    this.track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
  }

  startDrag(e) {
    this.isDown = true;
    this.track.classList.add('active');
    this.startX = e.pageX - this.track.offsetLeft;
    this.scrollLeft = this.track.scrollLeft;
  }

  stopDrag() {
    this.isDown = false;
    this.track.classList.remove('active');
  }

  drag(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.track.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.track.scrollLeft = this.scrollLeft - walk;
  }
  
  triggerScrollEvent() {
     this.track.dispatchEvent(new Event('scroll'));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.vc-wrapper');
  sections.forEach(el => new VideoCarousel(el));
});

document.addEventListener('shopify:section:load', (e) => {
  const container = e.target.querySelector('.vc-wrapper');
  if (container) new VideoCarousel(container);
});

  } catch(e) { console.error(e); }
})();
})();
